export default {"src":"/_next/static/media/logo-text.744cd038.svg","height":56,"width":281};